export default "__VITE_ASSET__BJNsiV1e__"